
<div class="flow-layout theme mode" :class="[theme, mode]">
	<div class="flow-layout-topbar">
		<transition mode="out-in" name="notification-slide">
			<div v-if="$slots['notification'] && !offline" class="flow-layout-notification">
				<slot name="notification" />
			</div>
			<div v-if="offline" class="flow-layout-notification">
				<div class="display-flex align-items-center j-c-c padding-16 bg-error flex-1 flex-gap-12">
					<Icon name="i-cloud-off" state="white" :effects="false" />
					<p class="paragraph-1 fc-dark fw-bold">No Connection.</p>
				</div>
			</div>
		</transition>
		<div v-if="$slots['navbar']" class="flow-layout-navbar flex-gap-8">
			<slot name="navbar" />
		</div>
	</div>
	<div class="flow-layout-body" :sidebar="$slots['sidebar'] != null" :opensidebar="openSidebar">
		<div v-if="$slots['sidebar']" class="flow-layout-sidebar" :open="openSidebar">
			<div class="flow-sidebar-mobile-trigger mobile">
				<Icon
					v-if="openSidebar"
					name="i-hamburger-close"
					type="filled"
					data-qa-toggle-sidebar-mobile
					@click="closeSidebar()"
				/>
				<Icon
					v-if="openSidebar"
					class="mobile"
					name="cldcvr"
					state="dark"
					type="filled"
					:effects="false"
					size="xxx-large"
				/>
			</div>
			<div v-if="isExpandable" class="flow-sidebar-header">
				<Container :padding="12">
					<Icon
						v-if="openSidebar"
						class="desktop"
						name="i-hamburger-close"
						state="light"
						type="filled"
						data-qa-toggle-sidebar-close
						@click="closeSidebar()"
					/>
					<Icon
						v-if="!openSidebar && isExpandable"
						class="desktop"
						name="i-hamburger"
						state="light"
						type="filled"
						data-qa-toggle-sidebar-open
						@click="toggleSidebar(true)"
					/>
				</Container>
				<slot name="sidebar-header" />
			</div>

			<slot name="sidebar" />
		</div>

		<div v-if="openSidebar" class="sidebar-blackout" @click="closeSidebar()" />
		<div class="flow-layout-content" @click="closeSidebar()">
			<slot />
		</div>
	</div>
	<transition mode="out-in" name="notification-slide">
		<div v-if="$slots['footer']" class="flow-layout-footerbar">
			<slot name="footer" />
		</div>
	</transition>
</div>
